/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-shadow */
/* eslint-disable no-return-assign */
import React, { useRef, useState, useEffect } from 'react';
import {
  HierarchicalTree,
  DataBinding,
  DiagramComponent,
  SnapConstraints,
  Inject,
  DiagramTools,
  PrintAndExport } from '@syncfusion/ej2-react-diagrams';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';

import { DataManager, Query } from '@syncfusion/ej2-data';
import { useNavigate } from 'react-router-dom';

// Initialize dataSource for diagram
/*
const data = [
  { id: 1, Label: 'Production Manager', color: '#1c5b9b' },
  { id: 2, Label: 'Control Room', parentId: 1, color: '#18c1be' },
  { id: 3, Label: 'Plant Operator', parentId: 1, color: '#18c1be' },
  { id: 4, Label: 'Foreman', parentId: 2, color: '#17a573' },
  { id: 5, Label: 'Foreman', parentId: 3, color: '#17a573' },
  { id: 6, Label: 'Craft Personnel', parentId: 4, color: '#73bb34' },
  { id: 7, Label: 'Craft Personnel', parentId: 4, color: '#73bb34' },
  { id: 8, Label: 'Craft Personnel', parentId: 5, color: '#73bb34' },
  { id: 9, Label: 'Craft Personnel', parentId: 5, color: '#73bb34' },
  { id: 10, Label: 'Administrative Officer', color: '#1c5b9b' },
  { id: 11, Label: 'Security Supervisor', parentId: 10, color: '#18c1be' },
  { id: 12, Label: 'HR Supervisor', parentId: 10, color: '#18c1be' },
  { id: 13, Label: 'Reception Supervisor', parentId: 10, color: '#18c1be' },
  { id: 14, Label: 'Securities', parentId: 11, color: '#17a573' },
  { id: 15, Label: 'HR Officer', parentId: 12, color: '#17a573' },
  { id: 16, Label: 'Receptionist', parentId: 13, color: '#17a573' },
  { id: 17, Label: 'Maintainence Manager', color: '#1c5b9b' },
  { id: 18, Label: 'Electrical Supervisor', parentId: 17, color: '#18c1be' },
  { id: 19, Label: 'Mechanical Supervisor', parentId: 17, color: '#18c1be' },
  { id: 20, Label: 'Craft Personnel', parentId: 18, color: '#17a573' },
  { id: 21, Label: 'Craft Personnel', parentId: 19, color: '#17a573' },
];
*/
// const items = new DataManager(data, new Query().take(7));
function OrgChart() {
  const navigate = useNavigate();
  const diagramInstance = useRef(null);

  const { REACT_APP_API_ENDPOINT } = process.env;
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=organizations');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [orgs, setOrgs] = useState([]);
  const makeColors = (steps) => Array.from({ length: steps }, (_, i) => {
    const hue = (i * (360 / steps)) % 360;
    return `hsl(${hue}, 80%, 60%)`;
  });
  const [colors, setColors] = useState(makeColors(100));
  // Print as PDF (using browser print dialog -> Save as PDF)
  const handlePrintPdf = () => {
    if (diagramInstance.current) {
      const options = {
        region: 'Content', // or 'Page'
        mode: 'Download',
      };
      diagramInstance.current.print(options);
    }
  };

  // Export as image formats (PNG, JPEG, SVG)
  const handleExportImage = () => {
    if (diagramInstance.current) {
      const options = {
        format: 'PNG',
        region: 'Content',
        mode: 'Download',
        fileName: 'MyOrganization_Diagram',
      };
      diagramInstance.current.exportDiagram(options);
    }
  };
  const [selectedNodeInfo, setSelectedNodeInfo] = useState(null);
  const [orgid, setOrgId] = useState('');

  const handleNodeClick = (args) => {
    if (args.source && args.source.orgid) {
      setOrgId(args.source.orgid);
    } else {
      setSelectedNodeInfo('');
    }
  };
  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const dataFetch = async () => {
      if (orgid === '') {
        return;
      }
      usr.organizationid = orgid;
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      let url = `${REACT_APP_API_ENDPOINT}/users?${query}&specific=true`;
      let mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();
      // set state when the data received
      let users = 'Users: ';
      if (mydata.users && mydata.users.length > 0) {
        mydata.users.forEach((user) => {
          const result = mydata.roles.find(({ _id }) => _id === user.role);
          if (result) {
            users += `${user.first} ${user.last} (${result.name}), `;
          }
        });
      }
      url = `${REACT_APP_API_ENDPOINT}/managers?${query}&specific=true`;
      mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();
      // set state when the data received
      let managers = 'Managers: ';
      if (mydata.managers && mydata.managers.length > 0) {
        mydata.managers.forEach((mgr) => {
          managers += `${mgr.first} ${mgr.last}, `;
        });
      }
      const msg = `${users}\n${managers}`;
      setSelectedNodeInfo(msg);
    };
    dataFetch();
  }, [orgid]);

  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const dataFetch = async () => {
      setLoading(true);
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/organizations?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();
      if (mydata) {
        // set state when the data received
        setData(mydata);
        const myorgs = [];
        mydata.organization.forEach((org, index) => {
          let children = 'none';
          if (org.children && org.children.length > 0) {
            children = '<br>';
            org.children.forEach((child) => {
              children += `${child.name} `;
            });
          }
          const o = { id: index + 1, _id: org._id, Label: org.title, color: '#F6821E', additionalInfo: { desc: `Details for ${org.title}, Children:${children}` } };
          myorgs.push(o);
        });
        const mycolors = makeColors(orgs.length);
        setColors(mycolors);
        mydata.organization.forEach((org, index) => {
          if (org.parent && org.parent._id !== org._id) {
            const result = myorgs.find(({ _id }) => _id === org.parent._id);
            if (result) {
              myorgs[index].parentId = result.id;
              myorgs[index].color = colors[result.id];
            }
          }
        });
        setOrgs(myorgs);
        setLoading(false);
      }
    };
    dataFetch();
  }, []);
  // sets node default value
  function nodeDefaults(obj) {
    const node = obj;
    node.style.fill = obj.data.color;
    node.backgroundColor = obj.data.color;
    node.style.color = '#02071A';
    node.style.strokeWidth = 2;
    node.width = 75;
    node.height = 35;
    node.shape.margin = { left: 5, right: 5, bottom: 5, top: 5 };
    node.additionalInfo = obj.data.additionalInfo;
    node.orgid = obj.data._id;
    return node;
  }
  // sets connector default value
  function connectorDefaults(connector) {
    const conn = connector;
    conn.style = { strokeColor: '#78DA89' }; // CornflowerBlue
    conn.targetDecorator = { shape: 'Arrow', height: 10, width: 10, style: { fill: '#78DA89', strokeColor: 'white' } }; // CornflowerBlue
    conn.type = 'Orthogonal';
    return conn;
  }

  if (loading) {
    return <p>Loading... </p>;
  }
  const items = new DataManager(orgs, new Query().take(7));
  return (
    <div className="control-pane diagram-control-pane">
      <ButtonComponent cssClass="e-large" iconCss="e-icons e-export-pdf" id="excel" onClick={handlePrintPdf}>Print/Save PDF</ButtonComponent>
      <ButtonComponent cssClass="e-large" iconCss="e-icons e-image" id="excel" onClick={handleExportImage}>Export PNG</ButtonComponent>
      <div style={{ width: '99%' }}>
        <div style={{ flex: 1, padding: '15px', border: '1px solid #ccc' }}>
          <h3>More Info</h3>
          <p style={{ whiteSpace: 'pre-line' }}>{selectedNodeInfo || 'Double Click a node to see details here.'}</p>
        </div>

        <DiagramComponent
          id="diagram"
          ref={diagramInstance}
          width="100%"
          height="799px"
          className="rounded-3xl zackat-divalh"
          doubleClick={(args) => { handleNodeClick(args); }}
          nodes={items}
          snapSettings={{ constraints: SnapConstraints.None }}
          // configures data source settings
          dataSourceSettings={{
            // sets the fields to bind
            id: 'id',
            parentId: 'parentId',
            dataSource: items,
            doBinding: (nodeModel, dt) => {
              const nm = nodeModel;
              nm.shape = {
                type: 'Text',
                content: dt.Label,
              };
            },
          }} // Disables all interactions except zoom and pan
          tool={DiagramTools.ZoomPan} // Configures automatic layout
          layout={{
            type: 'HierarchicalTree',
            verticalSpacing: 30,
            horizontalSpacing: 30,
          }} // Defines the default node and connector properties
          getNodeDefaults={(obj) => nodeDefaults(obj)}
          getConnectorDefaults={(connector) => connectorDefaults(connector)}
        >
          <Inject services={[DataBinding, HierarchicalTree, PrintAndExport]} />
        </DiagramComponent>
      </div>
    </div>
  );
}
export default OrgChart;
